import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  Output,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import {ReactBaseComponent} from '../../../react/base/react-base.component';
import {ManualPriceIncrease} from '../../../react/price/manual-price-increase';

const containerElementName = 'reactManualPriceIncreaseContainer';

@Component({
  selector: 'price-detail-manual-increase',
  template: `<div class="inline-block" #${containerElementName}></div>`,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PriceDetailManualIncreaseComponent extends ReactBaseComponent {
  @ViewChild(containerElementName, {static: false}) containerRef: ElementRef;
  @Input() oaNr: string;
  @Output() updated: EventEmitter<void> = new EventEmitter<void>();

  constructor(private ngZone: NgZone) {
    super();
  }

  onUpdated(): void {
    this.ngZone.run(() => {
      this.updated.emit();
    });
  }

  protected override renderComponent() {
    return <ManualPriceIncrease oaNr={this.oaNr}
                                labelButton="Preise erhöhen"
                                onUpdated={() => this.onUpdated()} />;
  }
}
